<template>
  <section>
    <h3>Bienvenido al Sistema</h3>
   
  </section>
</template>

<script>
  import FileUpload from '@/common/util/FileUpload.vue';
  import Demofi from '@/common/util/Demofi.vue';

  export default {
    components: {
      FileUpload,
      Demofi
    },
    methods: {
      showMessage (type) {
        console.log(type, this.$message);
        this.$message[type](`Mensaje tipo ${type}`);
      },
      showAlert () {
        this.$alert('Mensaje de alerta', function () {
          console.log('callback!!');
        });
      },
      showConfirm () {
        this.$confirm('Mensaje de confirmación', function () {
          console.log('ok!!');
        }, function () {
          console.log('cancel!!');
        });
      }
    }
  };
</script>




// WEBPACK FOOTER //
// src/components/admin/Dashboard.vue